export default "/images/306cb79b6aefb0c65d2d1a5ff9f15cc9.avif";